import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
//import {withRouter} from "react-router";
// -- redux
import { connect } from "react-redux";
import { ForgotPassword } from "../../Redux/Actions/ForgotPasswordAction";
import Loader from "../Loader";

function Forgot(props) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [response, setResponse] = useState("");
  const [hide, setHide] = useState(false);
  const [bankCode, setBankCode] = useState("");
  const [bankError, setBankError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (bankCode === "") {
      setBankError("Invalid bank code.");
      return;
    } else setBankError("");
    let emailRegex = /\S+@\S+\.\S+/;
    if (emailRegex.test(email)) {
      setEmailError("");
      const data = { email: email, bankcode: bankCode };
      props.ForgotPassword(data);
      setHide(true);
      setTimeout(function () {
        setResponse("");
        setHide(false);
        setEmailError("");
      }, 3000);
    } else {
      setEmailError("Invalid email");
    }
  };

  useEffect(() => {
    props.forget_data && props.forget_data.message && hide && setResponse(props.forget_data.message);
    props.forget_data &&
      props.forget_data.status === 200 &&
      props.history.push({
        pathname: "/otp-validate",
        state: { email, bankCode },
      });
  }, [props]);

  useEffect(() => {
    if (props?.forget_data?.response?.data?.error) setEmailError("Invalid credentials.");
    if (props?.forget_data?.error) setEmailError("Invalid credentials.");
  }, [props]);

  return (
    <>
      {props.loading && <Loader />}
      <form onSubmit={(e) => submit(e)}>
        <div className="mt-3 text-left">
          <label className="text-white w-100 mb-0" htmlFor="bankCode">
            <p className="mb-0 f-12">Bank Code</p>
            <input id="bankCode" type="text" placeholder="Your bank code" autoComplete="off" className={bankError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => setBankCode(e.target.value)} value={bankCode} />
          </label>
          {bankError && <span className="f-12 text-danger">{bankError}</span>}
        </div>
        <div className="mt-3 text-left">
          <label className="text-white w-100 mb-0" htmlFor="email">
            <p className="mb-0 f-12">Email</p>
            <input id="email" type="text" placeholder="Enter email" autoComplete="off" className={emailError ? "form-input-danger form-input f-14 mt-1 pb-1 text-white" : "form-input f-14 mt-1 pb-1 text-white"} onChange={(e) => setEmail(e.target.value)} value={email} />
          </label>
          {response && <p className="m-0 text-danger mt-1">{response}</p>}
          {emailError && <span className="f-12 text-danger mt-1">{emailError}</span>}
        </div>
        <button onClick={(e) => submit(e)} type="submit" className="form-button f-14 mt-5 centerMargin" disabled={!email}>
          continue
        </button>
        <p className="mt-5 text-white f-12 centerMargin">
          Did you remember your password?
          <Link to="/">
            <b className="pl-1 text-uppercase text-green">login Now</b>
          </Link>
        </p>
      </form>
    </>
  );
}

const mapStateToProps = ({ ForgotPasswordReducer }) => {
  const { loading, forget_data } = ForgotPasswordReducer;
  return { loading, forget_data };
};

const mapDispatchToProps = {
  ForgotPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Forgot));
